"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setStatus = exports.setPreloadingProcess = exports.selectStatus = exports.selectShopsInProcess = exports.selectPreloadingProcess = exports.selectPaging = exports.selectItems = exports.selectCategories = exports.resetStateAction = exports.reducer = exports.name = exports.getShopsRequestSuccessAction = exports.getShopsRequestFailAction = exports.getShopsRequestAction = exports.createShopAction = exports.changeShopStatusRequestSuccessAction = exports.changeShopStatusRequestFailAction = exports.changeShopStatusRequestAction = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _toolkit = require("@reduxjs/toolkit");

var REDUCER_NAME = 'module/shops';
var initialState = {
  items: [],
  categories: [],
  paging: {
    page: 0,
    pages: 0
  },
  error: null,
  shopsInProcess: [],
  status: null
};
var slice = (0, _toolkit.createSlice)({
  name: REDUCER_NAME,
  initialState: initialState,
  reducers: {
    resetStateAction: function resetStateAction(state) {
      state['items'] = [];
      state['categories'] = [];
      state['paging'] = {
        page: 0,
        pages: 0
      };
      state['error'] = null;
      state['shopsInProcess'] = [];
      state['status'] = null;
    },
    setPreloadingProcess: function setPreloadingProcess(state, _ref) {
      var payload = _ref.payload;
      state['preloadingProcess'] = payload;
    },
    setStatus: function setStatus(state, _ref2) {
      var payload = _ref2.payload;
      state['status'] = payload;
    },
    getShopsRequestAction: function getShopsRequestAction(state) {},
    getShopsRequestFailAction: function getShopsRequestFailAction(state) {},
    getShopsRequestSuccessAction: function getShopsRequestSuccessAction(state, _ref3) {
      var payload = _ref3.payload;
      state['items'] = payload;
    },
    changeShopStatusRequestAction: function changeShopStatusRequestAction(state, _ref4) {
      var payload = _ref4.payload;
      state['shopsInProcess'] = [].concat((0, _toConsumableArray2["default"])(state['shopsInProcess']), [payload]);
    },
    changeShopStatusRequestFailAction: function changeShopStatusRequestFailAction(state, _ref5) {
      var payload = _ref5.payload;
      state['shopsInProcess'] = state['shopsInProcess'].filter(function (shopId) {
        return shopId !== payload;
      });
    },
    changeShopStatusRequestSuccessAction: function changeShopStatusRequestSuccessAction(state, _ref6) {
      var payload = _ref6.payload;
      state['shopsInProcess'] = state['shopsInProcess'].filter(function (shopId) {
        return shopId !== payload;
      });
      state['items'] = state['items'].map(function (shop) {
        if (shop['id'] === payload['id']) {
          return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, shop), payload);
        }

        return shop;
      });
    },
    createShopAction: function createShopAction(state, _ref7) {
      var payload = _ref7.payload;
      state['items'] = [].concat((0, _toConsumableArray2["default"])(state['items']), [payload]);
    }
  }
});
var _slice$actions = slice['actions'],
    resetStateAction = _slice$actions.resetStateAction,
    setPreloadingProcess = _slice$actions.setPreloadingProcess,
    setStatus = _slice$actions.setStatus,
    getShopsRequestAction = _slice$actions.getShopsRequestAction,
    getShopsRequestFailAction = _slice$actions.getShopsRequestFailAction,
    getShopsRequestSuccessAction = _slice$actions.getShopsRequestSuccessAction,
    changeShopStatusRequestAction = _slice$actions.changeShopStatusRequestAction,
    changeShopStatusRequestFailAction = _slice$actions.changeShopStatusRequestFailAction,
    changeShopStatusRequestSuccessAction = _slice$actions.changeShopStatusRequestSuccessAction,
    createShopAction = _slice$actions.createShopAction;
exports.createShopAction = createShopAction;
exports.changeShopStatusRequestSuccessAction = changeShopStatusRequestSuccessAction;
exports.changeShopStatusRequestFailAction = changeShopStatusRequestFailAction;
exports.changeShopStatusRequestAction = changeShopStatusRequestAction;
exports.getShopsRequestSuccessAction = getShopsRequestSuccessAction;
exports.getShopsRequestFailAction = getShopsRequestFailAction;
exports.getShopsRequestAction = getShopsRequestAction;
exports.setStatus = setStatus;
exports.setPreloadingProcess = setPreloadingProcess;
exports.resetStateAction = resetStateAction;

var selectItems = function selectItems(state) {
  return state[REDUCER_NAME]['items'];
};

exports.selectItems = selectItems;

var selectCategories = function selectCategories(state) {
  return state[REDUCER_NAME]['categories'];
};

exports.selectCategories = selectCategories;

var selectPaging = function selectPaging(state) {
  return state[REDUCER_NAME]['paging'];
};

exports.selectPaging = selectPaging;

var selectShopsInProcess = function selectShopsInProcess(state) {
  return state[REDUCER_NAME]['shopsInProcess'];
};

exports.selectShopsInProcess = selectShopsInProcess;

var selectPreloadingProcess = function selectPreloadingProcess(state) {
  return state[REDUCER_NAME]['preloadingProcess'];
};

exports.selectPreloadingProcess = selectPreloadingProcess;

var selectStatus = function selectStatus(state) {
  return state[REDUCER_NAME]['status'];
};

exports.selectStatus = selectStatus;
var name = slice['name'];
exports.name = name;
var reducer = slice['reducer'];
exports.reducer = reducer;